import { Extension, Mark } from '@tiptap/core';

export const Strike = Mark.create({
  name: 'strike',
  parseHTML() {
    return [{ tag: 's' }, { tag: 'strike' }];
  },
  renderHTML() {
    return ['s', 0];
  },
  addCommands() {
    return {
      toggleStrike:
        () =>
        ({ commands }) =>
          commands.toggleMark(this.name),
    };
  },
});

export const Underline = Mark.create({
  name: 'underline',
  parseHTML() {
    return [
      { tag: 'u' },
      { style: 'text-decoration', consuming: false, getAttrs: (value) => value === 'underline' && null },
    ];
  },
  renderHTML() {
    return ['u', 0];
  },
  addCommands() {
    return {
      toggleUnderline:
        () =>
        ({ commands }) =>
          commands.toggleMark(this.name),
    };
  },
});

export const Highlight = Mark.create({
  name: 'highlight',
  parseHTML() {
    return [{ tag: 'mark' }];
  },
  renderHTML() {
    return ['mark', { class: 'editor-highlight' }, 0];
  },
  addCommands() {
    return {
      toggleHighlight:
        () =>
        ({ commands }) =>
          commands.toggleMark(this.name),
      unsetHighlight:
        () =>
        ({ commands }) =>
          commands.unsetMark(this.name),
    };
  },
});

export const TextAlign = Extension.create({
  name: 'textAlign',
  addOptions() {
    return { types: ['heading', 'paragraph'] };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: 'left',
            parseHTML: (element) => element.style.textAlign || 'left',
            renderHTML: (attributes) => {
              if (!attributes.textAlign || attributes.textAlign === 'left') {
                return {};
              }
              return { style: `text-align: ${attributes.textAlign}` };
            },
          },
        },
      },
    ];
  },
  addCommands() {
    return {
      setTextAlign:
        (alignment) =>
        ({ editor, commands }) => {
          const type = this.options.types.find((name) => editor.isActive(name));
          if (!type) {
            return false;
          }
          return commands.updateAttributes(type, { textAlign: alignment });
        },
      unsetTextAlign:
        () =>
        ({ editor, commands }) => {
          const type = this.options.types.find((name) => editor.isActive(name));
          if (!type) {
            return false;
          }
          return commands.resetAttributes(type, 'textAlign');
        },
    };
  },
});
